const Header = () => {
  return <h1 className="font-link">NC NEWS</h1>;
};

export default Header;
